import React from 'react';
import WidgetPost from '../WidgetPost';
import useWidgetPost from '../../hooks/useWidgetPost';

const EditorWrapper = ({ children }: { children: React.ReactNode }) => {
    const showWidget = useWidgetPost();

    return (
        <>
            {children}
            {showWidget && <WidgetPost />}
        </>
    );
};

export default EditorWrapper;
